import React, { type ReactNode } from 'react';

export default function WidgetsContainer({
  children,
}: {
  children?: ReactNode;
}) {
  return (
    <div
      className="pointer-events-none absolute top-10 bottom-10 right-0 flex flex-row-reverse items-start"
      style={{ zIndex: 2800 }}
    >
      {children}
    </div>
  );
}
